var Debug = {
	init:function(){
		if(Config.debug_mode){
			$(window).keypress(function (ev) {
				/*Debug.log("KEY : " + ev.keyCode);*/
				if(ev.keyCode == 33){
					$(".susy-debug").toggleClass("visible");
				}
				if(ev.keyCode == 42){
					$(".dump").toggleClass("visible");
				}
				if(ev.keyCode == 58){
					$(".screen-size").toggleClass("visible");
				}
			});
			
			$(window).resize(function(){
				Debug.resize();
			});
			Debug.resize();
			
			$(window).scroll(function(){
				Debug.scroll();
			});
			Debug.scroll();
		}
	},
	scroll:function(){
		$(".screen-size .scroll").html("scrollTop : " + $(window).scrollTop());
	},
	resize:function(){
		$(".screen-size .res").html(window.outerWidth +" x "+ window.outerHeight);
	},
	log:function(pValue){
		if(Config.debug_mode){
			console.log(pValue);
		}
	}
}
